// extracted by mini-css-extract-plugin
module.exports = {"open-panel-btn":"InsightsPanel-module__open-panel-btn__26WZR","root":"InsightsPanel-module__root__1UBSI"};